// extracted by mini-css-extract-plugin
export var subscription = "subscription-module--subscription--1PoNA";
export var container = "subscription-module--container--2lB8c";
export var form = "subscription-module--form--1p6Jl";
export var loading = "subscription-module--loading--2SwP_";
export var success = "subscription-module--success--9fUQH";